import React from 'react'
import * as Icons from 'ui/icons'
import { WhenModelValue } from '@morningtrain/react-resources'

function TrackCardIcon () {
  return (
    <>
      {/*
      <WhenModelValue name='status' condition='none'>
        <Icons.CheckmarkCircle className='text-available w-5 h-5 invisible' />
      </WhenModelValue>
      <WhenModelValue name='status' condition='approved'>
        <Icons.CheckmarkCircle className='text-available w-5 h-5 invisible' />
      </WhenModelValue>
      */}
      <WhenModelValue name='status' condition='pending'>
        <Icons.ExclamationCircle className='text-pending w-5 h-5' />
      </WhenModelValue>
    </>
  )
}

export default TrackCardIcon
